"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const getEnsuredAppIdFromProcessor_1 = __importDefault(require("../getEnsuredAppIdFromProcessor"));
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const buildCallablePushNotificationRequestPermission = (args) => async ({ executeProcesses, callbacks, functionId, processor, }) => {
    const appId = (0, getEnsuredAppIdFromProcessor_1.default)('PushNotificationRequestPermission', processor);
    const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)('PushNotificationRequestPermission', processor);
    try {
        await args.requestPermission({ appId });
        let token;
        try {
            token = await args.getToken(appId);
        }
        catch (error) {
            await processor.root.firebase.messaging().registerDeviceForRemoteMessages();
            token = await args.getToken(appId);
        }
        if (token) {
            const response = await processor.root.cloud.rendererUpdateCloudMessageToken({
                appId,
                messageToken: token,
                projectId,
            });
            if (!response.success) {
                throw new Error(response.errorMessage);
            }
        }
        executeProcesses(functionId, callbacks.success);
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        executeProcesses(functionId, callbacks.error, errorMessage);
    }
};
exports.default = buildCallablePushNotificationRequestPermission;
